module.exports = __webpack_public_path__ + "img/check-mark.3e0aa490.png";